import { useEffect } from "react";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { env } from "./env";
import { getApiClient } from "./lib/api-client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

function ApiTokenBridge() {
  const { getToken } = useAuth();
  useEffect(() => {
    const client = getApiClient(env.apiBaseUrl);
    client.setTokenProvider(() => getToken());
  }, [getToken]);
  return null;
}

export function App() {
  return (
    <ClerkProvider publishableKey={env.clerkPublishableKey}>
      <QueryClientProvider client={queryClient}>
        <ApiTokenBridge />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ClerkProvider>
  );
}
